// @flow

import { type IncomingPayment, getAddress, getPhoneNumber, getDocument, getCountry } from '@tectonics/prs/incoming-payment';
import { getZipcode } from '@tectonics/prs/address';
import { normalizeCustomerDocument } from './normalize-customer-document';
import { getZipcodeNormalizer, getPhoneNumberNormalizer } from '@tectonics/prs/customer/normalize';

export function normalizeCustomerIncomingPayment<T: IncomingPayment>(incomingPayment: T): T {
  const address = getAddress(incomingPayment);
  const country = getCountry(incomingPayment);

  return {
    ...incomingPayment,
    zipcode: getZipcodeNormalizer(country)(getZipcode(address)),
    phone_number: getPhoneNumberNormalizer(country)(getPhoneNumber(incomingPayment)),
    document: normalizeCustomerDocument(getDocument(incomingPayment)),
  };
}
